import React from "react";
import * as Icons from "react-icons/hi";
interface InputProps {
  label: string;
  name: string;
  type?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  hasLabel?: boolean;
  placeHolder?: string;
  icon?: {
    iconName: string;
    color?: string;
    size?: number;
  };
  onChange: (value: any) => void;
  data?: any;
}

const FileInput = (props: InputProps) => {
  const n = props.icon?.iconName ?? "";
  const IconComponent = (Icons as any)[n];

  const handleChange = (e: any) => {
    props.onChange(e.target.files[0]);
  };

  return (
    <div
      className={`flex flex-col ${
        props.hasLabel && "space-y-2"
      } w-[100%] relative my-2`}
    >
      {props.hasLabel && (
        <label>
          {props.label}{" "}
          <span className="text-red-600">{props.required ? "*" : ""}</span>
        </label>
      )}
      <span className="absolute top-3 left-4">
        {props.icon === undefined || props.icon === null ? null : (
          <IconComponent size={props.icon.size} color={props.icon.color} />
        )}
      </span>
      <input
        defaultValue={
          props.data
            ? props.data
            : null
        }
        onChange={handleChange}
        placeholder={props.placeHolder}
        type={props.type}
        name={props.name}
        className={`h-16 md:h-20 border-[1px] px-4 py-2 rounded-md border-[#E4E4E7] ${
          props.icon === undefined || props.icon === null ? "pl-3" : "pl-16"
        } ${props.className}`}
        disabled={props.disabled}
        required={props.required}
      />
    </div>
  );
};

export default FileInput;
